export default "__VITE_ASSET__DfLLBnzT__"